import { Model } from "@bryntum/schedulerpro";
import { STORE_KEYS } from "@/other/constants/StoreKeys.jsx";
import { HasProjectMixin } from "./mixins/HasProjectMixin";
import type { Location } from "./Location";
import type { Task } from "./Task";

export type SubmissionSource = "contact" | "ai_intake";

export class Submission extends HasProjectMixin(Model) {
  declare id: number;
  declare board: number;
  declare site: number;
  declare source: SubmissionSource;
  declare name: string;
  declare email: string;
  declare phone: string;
  declare message: string;
  declare additionalNotes: string;
  declare locationId: number | null;
  declare taskId: number | null;
  declare convertedAt: Date | null;
  declare createdAt: Date;
  declare updatedAt: Date;
  declare creator: number | null;
  declare updater: number | null;

  static get $name() {
    return "Submission";
  }

  static get fields() {
    return [
      "id",
      "board",
      "site",
      "source",
      "name",
      "email",
      "phone",
      "message",
      { name: "additionalNotes", dataSource: "additional_notes" },
      { name: "locationId", dataSource: "location", persist: false },
      { name: "taskId", dataSource: "task", persist: false },
      { name: "convertedAt", dataSource: "converted_at", type: "date", persist: false },
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "updatedAt", dataSource: "updated_at", type: "date" },
      { name: "creator", type: "number" },
      { name: "updater", type: "number" },
    ];
  }

  get isConverted(): boolean {
    return this.taskId != null || this.convertedAt != null;
  }

  get location(): Location | null {
    if (this.locationId == null) return null;
    return this.project?.locationStore?.getById(this.locationId) ?? null;
  }

  get task(): Task | null {
    if (this.taskId == null) return null;
    return this.project?.getCrudStore?.(STORE_KEYS.taskStore)?.getById(this.taskId) ?? null;
  }
}

// @ts-expect-error - exposeProperties is internal method
Submission.exposeProperties();
